import { useState } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import { useNavigate } from "react-router-dom";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

interface RaceData {
  race: string;
}

interface RacepageProps {
  onSubmit?: (data: RaceData) => void;
}

const Racepage = ({ onSubmit }: RacepageProps) => {
  const [selected, setSelected] = useState<string>("");
  const navigate = useNavigate();

  const handleSave = () => {
    if (selected) {
      SessionStorageHelper.saveField("race", selected);
      SessionStorageHelper.debugPrintData();

      if (onSubmit) {
        onSubmit({ race: selected });
      }

      navigate("/glucera" + GluceraNavigationRoutes.AGE_PAGE);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const raceOptions = [
    { display: "White", value: "white" },
    { display: "Black or African American", value: "black_african_american" },
    { display: "Asian", value: "asian" },
    {
      display: "American Indian or Alaska Native",
      value: "american_indian_alaska_native",
    },
    {
      display: "Native Hawaiian/Pacific Islander",
      value: "native_hawaiian_pacific_islander",
    },
    {
      display: "Middle Eastern or North African",
      value: "middle_eastern_north_african",
    },
    { display: "Other", value: "other" },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header with Progress */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          {/* <button
            onClick={handleBack}
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-muted/80 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button> */}
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 2 of 11
          </p>
        </div>

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto px-6 py-2 scrollbar-hide [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="mb-4 space-y-2">
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              What Is Your Race?
            </h1>
           
          </div>

          {/* What is Race explainer */}
          <div className="mb-4 rounded-xl border border-border bg-muted/50 p-4">
           
            <p className="text-xs leading-relaxed text-muted-foreground">
              Race refers to the social and ethnic group you identify with — such as Asian, Black, White, etc. It is <span className="font-medium text-foreground">not about skin color</span> alone. Research shows that diabetes risk, insulin resistance, and medication responses can differ across racial groups, helping us give you more accurate health recommendations.
            </p>
          </div>

          <div className="space-y-3 pb-4">
            {raceOptions.map(option => (
              <Card
                key={option.value}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selected === option.value
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
                onClick={() => setSelected(option.value)}
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="text-base font-semibold leading-tight">
                    {option.display}
                  </span>
                  <RadioDot selected={selected === option.value} />
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={handleSave}
            disabled={!selected}
            className={gluceraAssessmentCta}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Racepage;
